<template>
    <div class="share-detail">
        <div class="share-title">
            <div class="title-line"></div>
            <span class="title-content">份额明细</span>
        </div>
        <el-table
            :data="volList"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: '#F9F9F9' }"
        >
            <el-table-column label="支付银行卡">
                <template slot-scope="scope">
                    <div>
                        {{
                            $cache.getDict("110080", scope.row.bankcode) +
                            "(" +
                            scope.row.depositcard.substr(-4, 4) +
                            ")"
                        }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="资产(元)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.marketvalue) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="持有份额(份)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.currentshare) }}</span>
                </template>
            </el-table-column>
            <el-table-column label="可用份额(份)" align="center">
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.usableremainshare) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!$util.belongHx() && fundshowtype == 5"
                label="未转结收益"
                align="center"
            >
                <template slot-scope="scope">
                    <span>{{ $util.fmtNum(scope.row.income) }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";

export default {
    name: "ShareDetail",
    components: {},
    mixins: [mixin],
    props: {
        fundshowtype: {
            type: String,
            default: ""
        },
        volList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            list: []
        };
    },
    watch: {
        volList(val) {}
    }
};
</script>

<style lang="scss" scoped>
.share-detail {
    box-sizing: border-box;
    margin-bottom: 24px;
    .share-title {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
    }
}
.el-table {
    border: 1px solid #f1f1f1;
}
.el-table--fit {
    margin-bottom: 0;
}
.el-table td.el-table__cell div {
    color: #333333;
}
.el-table td.el-table__cell span {
    color: #333333;
}
</style>
